(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutech-vehicle-browser"] && !Shopify.designMode) return;
  try {
    
 (() => {
  function applyFitment(scope = document) {
   scope.querySelectorAll('[data-fitment-results]').forEach(root => {
    const list = root.querySelector('[data-fit-products]');
    if (!list) return;
    const year = new URLSearchParams(location.search).get('vehicle_year');
    const generation = root.dataset.generation;
    let count = 0;
    list.querySelectorAll('[data-fit-product]').forEach(card => {
     const start = Number(card.dataset.start), end = Number(card.dataset.end);
     let match = true;
     if (card.hasAttribute('data-universal')) match = true;
     else if (year === 'any') match = !start;
     else if (year) match = /^\d{4}$/.test(year) && start > 0 && Number(year) >= start && (!end || Number(year) <= end);
     else if (generation) match = card.dataset.generation === generation;
     card.hidden = !match;
     if (match) count++;
    });
    const countNode = root.querySelector('[data-fit-count]');
    const counts = JSON.parse(root.querySelector('[data-fit-counts]').textContent);
    if (countNode) countNode.textContent = counts[count] || String(count);
    root.querySelector('[data-fit-empty]').hidden = count !== 0;
    list.dataset.ready = 'true';
   });
  }
  applyFitment();
  document.addEventListener('shopify:section:load', e => applyFitment(e.target));
 })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutech-vehicle-finder"] && !Shopify.designMode) return;
  try {
    
 (() => {
  function init(scope = document) {
   scope.querySelectorAll('[data-nutech-finder]:not([data-initialized])').forEach(root => {
    root.dataset.initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-vehicle-data]').textContent);
    const form = root.querySelector('[data-finder]');
    if (!form) return;
    const makeSelect = form.elements.make, modelSelect = form.elements.model, yearSelect = form.elements.year;
    const message = root.querySelector('[data-message]');
    const selectedModel = () => data.makes.find(m => m.key === makeSelect.value)?.models.find(m => m.key === modelSelect.value);
    function updateYears() {
     yearSelect.replaceChildren(new Option(data.text.chooseYear, ''));
     const model = selectedModel(), years = new Set();
     (model?.fits || []).forEach(fit => {
      if (!fit.start) return;
      const lastYear = fit.end || Number(root.dataset.currentYear);
      for (let year = fit.start; year <= lastYear; year++) years.add(year);
     });
     Array.from(years).sort((a,b) => b-a).forEach(year => yearSelect.add(new Option(String(year),String(year))));
     if (model?.fits.some(fit => !fit.start)) yearSelect.add(new Option(data.text.anyYear, 'any'));
     yearSelect.disabled = !model;
     message.hidden = true;
    }
    function updateModels() {
     modelSelect.replaceChildren(new Option(data.text.chooseModel, ''));
     const make = data.makes.find(m => m.key === makeSelect.value);
     (make?.models || []).filter(m => m.fits.length).slice().sort((a,b) => a.name.localeCompare(b.name,undefined,{numeric:true})).forEach(model => modelSelect.add(new Option(model.name,model.key)));
     modelSelect.disabled = !make;
     updateYears();
    }
    makeSelect.addEventListener('change',updateModels);
    modelSelect.addEventListener('change',updateYears);
    yearSelect.addEventListener('change',() => { message.hidden = true; });
    if (root.dataset.currentMake) { makeSelect.value = root.dataset.currentMake; updateModels(); }
    if (root.dataset.currentModel) { modelSelect.value = root.dataset.currentModel; updateYears(); }
    const incoming = new URLSearchParams(location.search).get('vehicle_year');
    if (incoming && Array.from(yearSelect.options).some(o => o.value === incoming)) yearSelect.value = incoming;
    form.addEventListener('submit',event => {
     event.preventDefault();
     if (root.hasAttribute('data-navigating') || !form.reportValidity()) return;
     const model = selectedModel(), year = yearSelect.value;
     if (!model || !year) return;
     const valid = year === 'any' ? model.fits.some(f => !f.start) : model.fits.some(f => f.start && Number(year) >= f.start && (!f.end || Number(year) <= f.end));
     if (!valid) { message.textContent = data.text.noMatch; message.hidden = false; return; }
     const url = new URL(model.page,location.origin);
     url.searchParams.set('vehicle_year',year);
     if (url.pathname === location.pathname && url.search === location.search) {
      document.getElementById('VehicleResults')?.scrollIntoView({behavior:'instant',block:'start'});
      return;
     }
     root.dataset.navigating = 'true';
     form.setAttribute('aria-busy','true');
     form.querySelector('button[type="submit"]').disabled = true;
     location.assign(url.pathname + url.search + '#VehicleResults');
    });
    if (incoming && selectedModel()) {
     const selection = root.querySelector('[data-selection]');
     if (incoming === 'any' && selectedModel().fits.some(f => !f.start)) selection.textContent = data.text.anyYearNote;
     else {
      const matches = selectedModel().fits.filter(f => f.start && Number(incoming) >= f.start && (!f.end || Number(incoming) <= f.end));
      const labels = [...new Set(matches.map(f => f.label).filter(Boolean))];
      selection.textContent = matches.length ? incoming + ' · ' + data.text.matches + ' ' + labels.join(' / ') + '. ' + data.text.verify : data.text.noMatch;
     }
     selection.hidden = false;
    }
    form.hidden = false;
   });
  }
  init();
  document.addEventListener('shopify:section:load',e => init(e.target));
  window.addEventListener('pageshow',() => {
   document.querySelectorAll('[data-nutech-finder][data-navigating]').forEach(root => {
    delete root.dataset.navigating;
    const form = root.querySelector('[data-finder]');
    form.removeAttribute('aria-busy');
    form.querySelector('button[type="submit"]').disabled = false;
   });
  });
 })();

  } catch(e) { console.error(e); }
})();
})();
